export const CHANGEABLE_CATEGORIES = [
  'Hat',
  'Clothing',
  'Gloves',
  'Weapon',
  'Boots',
  'Companion',
  'Affiliation',
  'Transportation',
  'Home Comfort',
  'HomeComfort',
];

export const STANDARD_CATEGORIES = [
  'Hat',
  'Clothing',
  'Gloves',
  'Weapon',
  'Boots',
  'Companion',
  'Destiny',
];

export const EXPANDED_CATEGORIES = [
  'Affiliation',
  'Transportation',
  'Home Comfort',
  'Ship',
  'Spouse',
  'Club',
];